<section class="min-h-screen bg-[#f3f3f3] px-3 pb-8 pt-5 sm:px-5 lg:px-8">
  <div class="mx-auto max-w-[1600px]">
    <div class="grid grid-cols-1 gap-5 lg:grid-cols-[300px_minmax(0,1fr)] xl:grid-cols-[340px_minmax(0,1fr)]">
      <app-profile-sidebar></app-profile-sidebar>

      <div class="min-w-0">
        <div #tabBar
          class="mb-4 flex items-center justify-between gap-3 rounded-xl border border-[#e8e8e8] bg-white px-3">
          <div class="overflow-x-auto">
            <div class="flex min-w-max items-center gap-6 sm:gap-8">
              <button type="button" *ngFor="let tab of tabs; trackBy: trackByTabLabel" (click)="setTab(tab)"
                class="border-b-2 py-3 text-sm font-medium transition-colors" [ngClass]="
                  activeTab === tab.label
                    ? 'border-[#e91e63] text-[#e91e63]'
                    : 'border-transparent text-gray-500 hover:text-gray-700'
                ">
                {{ tab.label }}
              </button>
            </div>
          </div>
        </div>

        <!-- Its own row, right-aligned — sharing the tab bar left the tabs with
             too little width to scroll comfortably on phones and tablets. -->
        <div *ngIf="showCollabToggle" class="mb-3 flex items-center justify-end gap-2">
          <button type="button" (click)="toggleCollabOnly()" role="switch" [attr.aria-checked]="collabOnly"
            aria-label="Show only collaborated content"
            class="relative inline-flex h-5 w-9 flex-shrink-0 items-center rounded-full transition-colors"
            [style.background-color]="collabOnly ? '#e91e63' : '#d1d5db'">
            <span class="inline-block h-3.5 w-3.5 transform rounded-full bg-white transition-transform"
              [style.transform]="collabOnly ? 'translateX(18px)' : 'translateX(3px)'"></span>
          </button>
          <span class="whitespace-nowrap text-sm text-gray-600">Collaborations only</span>
        </div>
        <app-posts *ngIf="activeType === 'post'" [userName]="userName" [embedded]="true"
          [collabOnly]="collabOnly"></app-posts>
        <app-blog *ngIf="activeType === 'blog'" [userName]="userName" [embedded]="true"
          [showStatusFilter]="isOwnProfile" [collabOnly]="collabOnly"></app-blog>
        <app-events *ngIf="activeType === 'event'" [userName]="userName" [embedded]="true"
          [collabOnly]="collabOnly"></app-events>
        <app-user-reactions *ngIf="activeType === 'reaction'" [userName]="userName"></app-user-reactions>

        <app-followers-following *ngIf="activeType === 'follower'" [type]="'follower'" [userName]="userName">
        </app-followers-following>

        <app-followers-following *ngIf="activeType === 'following'" [type]="'following'" [userName]="userName">
        </app-followers-following>

        <app-friends-list *ngIf="activeType === 'friend'" [userName]="userName"></app-friends-list>

        <app-blocked-users *ngIf="activeType === 'blocked' && isOwnProfile"></app-blocked-users>
      </div>
    </div>
  </div>
</section>

<app-scroll-to-top />
